import { render, staticRenderFns } from "./change-record.vue?vue&type=template&id=7102c45e&scoped=true&lang=pug&"
import script from "./change-record.vue?vue&type=script&lang=js&"
export * from "./change-record.vue?vue&type=script&lang=js&"
import style0 from "./change-record.vue?vue&type=style&index=0&id=7102c45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7102c45e",
  null
  
)

export default component.exports